import { gql } from "@apollo/client";

const RAISE_BACKUP_REQUEST = gql`
  mutation RaiseBackupRequest($params: BackupRequestInputParams!) {
    backupRequest(params: $params) {
      id
      remittanceItemId
      processId
    }
  }
`;

export default RAISE_BACKUP_REQUEST;
